module.exports = __webpack_public_path__ + "static/media/ODS1.6e298ccb.jpeg";